import extenso from "extenso";
import { FuncaoService, Login, Relatorio, GlobalService, Empenho, OrgaoAssinaturaService, LicitacaoPipe, EmpenhoStorage, Rcms, Unidade, Executora } from 'eddydata-lib';
import JsBarcode from 'jsbarcode';
import { PendenciaAssinaturaService } from 'projects/eddydata-lib/src/lib/pendencia-assinatura/service/pendencia-assinatura.service';
import { EmpenhoStorageService } from 'contabil-lib';
import { PDFDocument } from 'pdf-lib';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { filter, first, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { CompraService, NotaCompra, RcmsFavorecidorService, RcmsItemService, RcmsService } from "compra-lib";
import { MemorialService, PropostaService } from "administrativo-lib";
import { NotaRcmsRpt } from "projects/compra-lib/src/lib/rcms/nota-rcms-rpt/nota-rcms-rpt.component";
import { RcmsStorageService } from "projects/compra-lib/src/lib/rcms/service/rcms-storage.service";
import { ChangeDetectorRef, ViewChild, Injectable, Component, EventEmitter } from "@angular/core";
import { ImprimirNotaRcmsRpt } from "projects/compra-lib/src/lib/rcms/nota-rcms-rpt/imprimir-nota-rcms-rpt/imprimir-nota-rcms-rpt.component";


(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

export class NotaEmpenho {

  protected funcaoService: FuncaoService;
  protected globalService: GlobalService;

  public nota: NotaRcmsRpt;

  private log: Login;
  private ordenador_despesa: string;
  private cargo_ordenador_despesa: string;
  private ordenador_despesa_funcao_08: string;
  private cargo_ordenador_despesa_funcao_08: string;
  private ordenador_despesa_funcao_03: string;
  private cargo_ordenador_despesa_funcao_03: string;
  private ordenador_despesa_funcao_06: string;
  private cargo_ordenador_despesa_funcao_06: string;
  private ordenador_despesa_funcao_10: string;
  private cargo_ordenador_despesa_funcao_10: string;
  private ordenador_despesa_funcao_11: string;
  private cargo_ordenador_despesa_funcao_11: string;
  private ordenador_despesa_funcao_12: string;
  private cargo_ordenador_despesa_funcao_12: string;
  private ordenador_despesa_funcao_13: string;
  private cargo_ordenador_despesa_funcao_13: string;
  private ordenador_despesa_funcao_15: string;
  private cargo_ordenador_despesa_funcao_15: string;
  private ordenador_despesa_funcao_16: string;
  private cargo_ordenador_despesa_funcao_16: string;
  private ordenador_despesa_funcao_18: string;
  private cargo_ordenador_despesa_funcao_18: string;
  private ordenador_despesa_funcao_20: string;
  private cargo_ordenador_despesa_funcao_20: string;
  private ordenador_despesa_funcao_23: string;
  private cargo_ordenador_despesa_funcao_23: string;
  private ordenador_despesa_funcao_26: string;
  private cargo_ordenador_despesa_funcao_26: string;
  private ordenador_despesa_funcao_27: string;
  private cargo_ordenador_despesa_funcao_27: string;
  private ordenador_pagto: string;
  private ordenador: string;
  private cargoOrdenador: string;
  private cargo_ordenador_pagto: string;
  private contador: string;
  private cargo_contador: string;
  private tesoureiro: string;
  private cargo_tesoureiro: string;
  public arquivosSubject: BehaviorSubject<any | null> = new BehaviorSubject(null);
  private arquivosRCMS = this.arquivosSubject.asObservable();
  private arquivosCompraSubject: BehaviorSubject<any | null> = new BehaviorSubject(null);
  private arquivosCompra = this.arquivosCompraSubject.asObservable();
  protected unsubscribe: Subject<void> = new Subject();

  constructor(protected assinaturaService: OrgaoAssinaturaService,
    protected pendenciaAssinaturaService: PendenciaAssinaturaService,
    protected empenhoStorageService: EmpenhoStorageService,
    protected rcmsFavorecidoService: RcmsFavorecidorService,
    protected rcmsItemService: RcmsItemService,
    private rcmsService: RcmsService,
    private compraService: CompraService,
    public propostaService: PropostaService,
    protected storageService: RcmsStorageService,
    protected cd: ChangeDetectorRef,
  ) {
    this.funcaoService = new FuncaoService();
    this.globalService = new GlobalService();
  }

  public async imprimirAssinatura(empenho: any[], unificarArquivos: boolean, download: boolean, url: boolean, modelo?: string) {
    this.log = empenho['login']
    await Promise.all(empenho.map(async (item) => {
      const wrapper = [item];
      wrapper['arquivos'] = item['arquivos'] || [];

      if (item?.compra?.id) {
        await this.processarEmpenho(wrapper);
        item['arquivos'] = wrapper['arquivos'];
      }
    }));
    if (empenho.length > 1) {
      if (unificarArquivos) {
        const todosArquivos = [];

        for (const emp of empenho) {
          let temArquivoAssinado = false;
          let pendencia = await this.pendenciaAssinaturaService.obter({ 'id_entidade': emp.id, 'etapa.etapa.nome': 'NOVO_EMPENHO', 'status$ne': 'EXCLUIDO', 'aceito$null': true, 'orderBy': 'etapa.ordem$DESC' }).toPromise();

          if (!pendencia?.id) {
            pendencia = await this.pendenciaAssinaturaService.obter({ 'id_entidade': emp.id, 'etapa.etapa.nome': 'NOVO_EMPENHO', 'status': 'CONCLUIDO', 'orderBy': 'etapa.ordem$DESC' }).toPromise();
          }
          if (pendencia && pendencia.id_storage) {
            let param = {}
            if (pendencia.status === 'CONCLUIDO') {
              param['descricao$like'] = 'Documento assinado digitalmente%';
              param['empenho.id'] = pendencia.id_entidade;
              param['orderBy'] = 'id$DESC'
              param['assinatura'] = true;
            } else {
              param['id'] = pendencia.id_storage;
            }
            const rcmsStorage = await this.empenhoStorageService.obter(param).toPromise();
            if (rcmsStorage) {
              temArquivoAssinado = true
              emp['arquivos'].unshift(rcmsStorage);
            }
          }
          if (!temArquivoAssinado) {
            const cont = await this.montarConteudo([emp], modelo);
            if (cont) {
              const pdfMakeDoc: any = {
                content: cont,
                styles: {
                  header: {
                    bold: true,
                    fontSize: 14,
                    alignment: 'center'
                  },
                  sub_header: {
                    fontSize: 10,
                    alignment: 'center'
                  },
                  footer: {
                    fontSize: 8
                  }
                },
                defaultStyle: { fontSize: 8 },
                compress: true,
                pageMargins: [30, 20, 30, 20],
                pageSize: 'A4',
                pageOrientation: 'portrait'
              };

              const pdfMakeBuffer = await new Promise<Uint8Array>((resolve) => {
                pdfMake.createPdf(pdfMakeDoc).getBuffer((buffer) => resolve(buffer));
              });

              const pdfBlob = new Blob([pdfMakeBuffer], { type: 'application/pdf' });

              if (!emp['arquivos']) emp['arquivos'] = [];

              emp['arquivos'].unshift({
                url: pdfBlob,
                tipo: 'application/pdf',
              });
            }
          }

          if (emp['arquivos']) todosArquivos.push(...emp['arquivos']);
        }

        const blobFinal = await this.gerarPdfUnico(todosArquivos, null, empenho);
        this.abrirOuBaixarBlob(blobFinal, false, false);
      } else {
        this.imprimir(empenho, empenho['login'], modelo);
      }
    } else if (empenho?.length === 1) {
      let pendencia = await this.pendenciaAssinaturaService.obter({ 'id_entidade': empenho[0].id, 'etapa.etapa.nome': 'NOVO_EMPENHO', 'status$ne': 'EXCLUIDO', 'aceito$null': true, 'orderBy': 'etapa.ordem$DESC' }).toPromise();

      if (!pendencia?.id) {
        pendencia = await this.pendenciaAssinaturaService.obter({ 'id_entidade': empenho[0].id, 'etapa.etapa.nome': 'NOVO_EMPENHO', 'status': 'CONCLUIDO', 'orderBy': 'etapa.ordem$DESC' }).toPromise();
      }
      if (pendencia && pendencia.id_storage) {
        let param = {}
        if (pendencia.status === 'CONCLUIDO') {
          param['descricao$like'] = 'Documento assinado digitalmente%';
          param['empenho.id'] = pendencia.id_entidade;
          param['orderBy'] = 'id$DESC'
          param['assinatura'] = true;
        } else {
          param['id'] = pendencia.id_storage;
        }
        const rcmsStorage = await this.empenhoStorageService.obter(param).toPromise();
        if (rcmsStorage) {
          if (url) {
            if (unificarArquivos) {
              empenho['arquivos'].unshift(rcmsStorage)
              if (empenho[0]?.compra?.id && !empenho['assinar']) {
                await this.processarEmpenho(empenho);
              }
              //
              const blob = await this.gerarPdfUnico(empenho['arquivos'], null, empenho)
              const url = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.target = '_blank';
              link.click();
            } else {
              return new Blob([await this.empenhoStorageService.downloadArquivo(encodeURIComponent(rcmsStorage.url)).toPromise()], { type: 'application/pdf' });
            }
          } else {
            if (unificarArquivos && empenho['novaAba']) {
              empenho['arquivos'].unshift(rcmsStorage)
              if (empenho[0]?.compra?.id && !empenho['assinar']) {
                await this.processarEmpenho(empenho);
              }
              const blob = await this.gerarPdfUnico(empenho['arquivos'], null, empenho)
              const url = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.target = '_blank';
              link.click();
            } else if (unificarArquivos && !empenho['assinar'] && !empenho['novaAba']) {
              empenho['arquivos'].unshift(rcmsStorage)
              return await this.gerarPdfUnico(empenho['arquivos'], null, empenho)
            } else {
              const blob = new Blob([await this.empenhoStorageService.downloadArquivo(encodeURIComponent(rcmsStorage.url)).toPromise()], { type: 'application/pdf' });
              const url = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.target = '_blank';
              link.click();
            }
          }
        } else {
          this.imprimir(empenho, empenho['login'], null);
        }
      } else {
        if (unificarArquivos && !empenho['assinar'] && !empenho['novaAba']) {
          return await this.gerarPdfUnico(empenho['arquivos'], await this.montarConteudo(empenho), empenho)
        } else if (unificarArquivos && !empenho['assinar'] && empenho['novaAba']) {
          // let arquivos = empenho['arquivos'];
          if (empenho[0]?.compra?.id && !empenho['assinar']) {
            await this.processarEmpenho(empenho);
          }
          const blob = await this.gerarPdfUnico(empenho['arquivos'], await this.montarConteudo(empenho), empenho)
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.target = '_blank';
          link.click();
        } else if (download && empenho['assinar'] && !empenho['novaAba']) {
          return await this.gerarPdfUnico([], await this.montarConteudo(empenho), empenho);
        }
        else {
          this.imprimir(empenho, empenho['login'], modelo);
        }
      }
    } else {
      this.imprimir(empenho, empenho['login'], modelo);
    }

    return null;
  }

  async gerarPdfUnico(arquivos: EmpenhoStorage[], nota: any, empenho: Empenho[]) {
    const finalPdf = await PDFDocument.create();
    if (nota) {
      const pdfMakeDoc: any = {
        content: nota,
        styles: {
          header: {
            bold: true,
            fontSize: 14,
            alignment: 'center'
          },
          sub_header: {
            fontSize: 10,
            alignment: 'center'
          },
          footer: {
            fontSize: 8
          }
        },
        defaultStyle: {
          fontSize: 8,
        },
        compress: true,
        pageMargins: [30, 20, 30, 20],
        pageSize: 'A4',
        pageOrientation: 'portrait'
      };

      const pdfMakeBuffer = await new Promise<Uint8Array>((resolve) => {
        pdfMake.createPdf(pdfMakeDoc).getBuffer((buffer) => resolve(buffer));
      });

      const mainDoc = await PDFDocument.load(pdfMakeBuffer);
      const mainPages = await finalPdf.copyPages(mainDoc, mainDoc.getPageIndices());
      mainPages.forEach((page) => finalPdf.addPage(page));

    }

    const arquivosExternos = [];
    for (const arquivo of arquivos) {
      if (arquivo?.tipo == 'application/pdf') {
        arquivosExternos.push(arquivo.url)
      }
    }
    for (const url of arquivosExternos) {
      const arrayBuffer = url instanceof Blob ? await url.arrayBuffer() : await this.empenhoStorageService.downloadArquivo(encodeURIComponent(url)).toPromise().then(res => res.arrayBuffer())//await fetch
      const externalDoc = await PDFDocument.load(arrayBuffer);
      const externalPages = await finalPdf.copyPages(externalDoc, externalDoc.getPageIndices());
      externalPages.forEach((page) => finalPdf.addPage(page));
    }
    finalPdf.setTitle('Empenho ' + (empenho.length > 1 ?
      `(${empenho.map((r) => r.numero).join(',')})` :
      empenho[0].numero))
    const pdfBytes = await finalPdf.save();
    return new Blob([pdfBytes], { type: 'application/pdf', });
  }

  private async preencheAssinatura() {
    const assinatura = await this.assinaturaService.obter({
      orgao_id: this.log.orgao.id,
      'data_limite$ge': String(this.funcaoService.converteDataSQL(new Date().toLocaleDateString()))
    }).toPromise();
    if (assinatura) {
      this.ordenador_despesa = assinatura.ordenador_despesa;
      this.cargo_ordenador_despesa = assinatura.cargo_ordenador_despesa;

      this.ordenador_despesa_funcao_08 = assinatura.ordenador_despesa_funcao_08;
      this.cargo_ordenador_despesa_funcao_08 = assinatura.cargo_ordenador_despesa_funcao_08;

      this.ordenador_despesa_funcao_10 = assinatura.ordenador_despesa_funcao_10;
      this.cargo_ordenador_despesa_funcao_10 = assinatura.cargo_ordenador_despesa_funcao_10;

      this.ordenador_despesa_funcao_12 = assinatura.ordenador_despesa_funcao_12;
      this.cargo_ordenador_despesa_funcao_12 = assinatura.cargo_ordenador_despesa_funcao_12;

      this.ordenador_despesa_funcao_13 = assinatura.ordenador_despesa_funcao_13;
      this.cargo_ordenador_despesa_funcao_13 = assinatura.cargo_ordenador_despesa_funcao_13;

      this.ordenador_pagto = assinatura.ordenador_pagto;
      this.cargo_ordenador_pagto = assinatura.cargo_ordenador_pagto;

      this.tesoureiro = assinatura.tesoureiro;
      this.cargo_tesoureiro = assinatura.cargo_tesoureiro;

      this.contador = assinatura.contador;
      this.cargo_contador = assinatura.cargo_contador;
    }
  }

  private retornaLayout() {
    return {
      linhas: {
        hLineWidth() {
          return 1;
        },
        vLineWidth() {
          return 1;
        },
        hLineColor() {
          return 'black';
        },
        paddingLeft() {
          return 3;
        },
        paddingRight() {
          return 3;
        }
      }
    };
  }

  public async criarPdf(model: Empenho[], login: Login): Promise<pdfMake.TCreatedPdf> {
    this.log = login;
    // await this.preencheAssinatura()

    return await Relatorio.imprimirPersonalizado('NOTA DE EMPENHO', login.usuario.nome, login.usuario.sobrenome,
      login.orgao.nome, login.brasao, await this.montarConteudo(model), 'portrait', `nota_empenho_${model[0].numero}`, this.retornaLayout(), true, true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, true)
  }

  public async imprimir(model: Empenho[], login: Login, modelo?: string, assinaturaDigital?: boolean) {
    this.log = login;
    // await this.preencheAssinatura()

    if (assinaturaDigital) {
      model['login'] = login;
      this.imprimirAssinatura(model, true, true, true, modelo);
    } else {
      await Relatorio.imprimirPersonalizado('NOTA DE EMPENHO', login.usuario.nome, login.usuario.sobrenome,
        login.orgao.nome, login.brasao, await this.montarConteudo(model, modelo), 'portrait', 'NOTA EMPENHO', this.retornaLayout(), true, true)
    }

  }

  private async montarConteudo(lista: Empenho[], modelo?: string) {
    const conteudo = [];

    for (const entidade of lista) {
      if (conteudo.length > 0) {
        conteudo.push([{ text: '', pageBreak: 'after' }]);
      }
      const canvas = document.createElement('CANVAS') as HTMLCanvasElement;
      const barCode = `018170${this.funcaoService.strZero((+entidade.valor_empenho).toFixed(2), 12).split('.').join('')}` +
        `${this.log.orgao.codigo.substring(0, 4)}${this.funcaoService.converteDataSQL(new Date(entidade.data_empenho)).split('-').join('')}` +
        `${this.funcaoService.strZero(entidade.numero, 10)}0000090`;

      JsBarcode(canvas, String(barCode), { displayValue: false, height: 70, margin: 0 });
      conteudo.push(this.dadosCabecalho(this.log, entidade)
        .concat(this.dadosEmpenho(entidade))
        .concat(this.dadosClassificacao(entidade))
        .concat(this.dadosContrato(entidade))
        .concat(this.dadosFavorecido(entidade))
        .concat(this.dadosHistorico(entidade))
        .concat(await this.dadosAutorizacao(entidade))
        .concat(this.dadosAssinatura(this.log, modelo))
        .concat(this.dadosRecibo()).concat([{
          image: canvas.toDataURL(),
          fit: [250, 70], margin: [10, 5]//, absolutePosition: { x: 280, y: -90 }
        }]));
    }
    return conteudo;
  }

  private dadosCabecalho(log: Login, entidade: Empenho): {}[] {
    const anulacao = entidade.especie === 'EOA'

    let brasaoImage: {};
    if (log.brasao) {
      brasaoImage = {
        image: log.brasao,
        width: 70,
        alignment: 'left',
        margin: [0, 0, 0, 0],
        border: [true, true, false, false]
      };
    } else {
      brasaoImage = { margin: [0, 10, 0, 0], text: '', border: [true, true, false, false] };
    }

    brasaoImage['rowSpan'] = 4;

    const conteudo = [
      [brasaoImage, { text: log.orgao.nome, bold: true, alignment: 'center', fontSize: 14, border: [false, true, true, false] }],
      [
        { text: '', border: [false, false, false, false], margin: [0, 0, 0, 0] },
        {
          text: `${log.orgao.endereco} ${log.cidade?.nome} ${log.cidade?.estado?.nome} CNPJ: ${log.orgao.cnpj}`,
          alignment: 'center', fontSize: 8, border: [false, false, true, false]
        }
      ], [
        { text: '', border: [true, false, false, false], margin: [0, 0, 0, 0] },
        {
          text: !anulacao ? `EMPENHO ORÇAMENTÁRIO` : `ANULAÇÃO EMPENHO ORÇAMENTÁRIO`,
          bold: true, alignment: 'center', fontSize: 14, border: [false, false, true, false]
        }
      ], [
        { text: '', border: [true, false, false, false], margin: [0, 0, 0, 0] },
        { text: `${log.exercicio.ano}`, bold: true, alignment: 'center', fontSize: 12, border: [false, false, true, false] }
      ]
    ];

    return [{
      layout: 'linhas',
      table: {
        // dontBreakRows: true,
        widths: [50, '*'],
        body: conteudo
      }
    }];
  }

  private dadosEmpenho(dados: Empenho): {}[] {
    const tipoEmpenho = this.globalService.obterListaTiposEmpenhos().find(x => x.id === dados.tipo_empenho);
    const modalidade = dados.modalidade?.nome?.length > 21 ? dados.modalidade?.nome?.split(' ', 3).join(' ') : dados.modalidade?.nome;
    const conteudo = [
      [
        {
          text: `EMPENHO Nº ${this.funcaoService.strZero(dados.numero, 4)}`,
          rowSpan: 2, fontSize: 11, alignment: 'left', bold: true, margin: [0, 8, 8, 8]
        },
        { text: 'Ficha', fontSize: 7, border: [true, true, false, false] },
        { text: 'Tipo', fontSize: 7, border: [true, true, false, false] },
        { text: 'Data', fontSize: 7, border: [true, true, false, false] },
        { text: 'Previsão', fontSize: 7, border: [true, true, false, false] },
        { text: 'Licitação', fontSize: 7, border: [true, true, false, false] },
        { text: 'Processo', fontSize: 7, border: [true, true, false, false] },
        { text: 'Modalidade Licitação', fontSize: 7, border: [true, true, true, false] }
      ], [
        { text: '' },
        { text: dados.ficha?.numero, alignment: 'center', fontSize: 12, bold: true, border: [false, false, false, true] },
        {
          text: tipoEmpenho ? tipoEmpenho.nome : ' - ',
          alignment: 'center', bold: true, border: [true, false, false, true]
        },
        {
          text: this.funcaoService.converteDataBR(dados.data_empenho),
          alignment: 'center', bold: true, border: [true, false, false, true]
        },
        {
          text: this.funcaoService.converteDataBR(dados.data_vencimento),
          alignment: 'center', bold: true, border: [true, false, false, true]
        },
        {
          text: dados.licitacao ? `${new LicitacaoPipe().transform(dados.licitacao?.numero)}` : ' - ',
          alignment: 'center', bold: true, border: [true, false, false, true]
        },
        { text: dados.processo, alignment: 'center', bold: true, border: [true, false, false, true] },
        { text: modalidade, bold: true, border: [true, false, true, true] },
      ]
    ];

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        headerRows: 2,
        widths: [115, 30, 50, 45, 45, 50, 50, '*'],
        body: conteudo
      }
    }];
  }

  private dadosClassificacao(dados: Empenho): {}[] {
    const dotacao = (+dados.total_dotacao_ficha + +dados.total_creditado_ficha) - +dados.total_reservado;
    const anterior = +dotacao - +dados.total_empenhado_ficha_anterior;
    let saldo = 0;
    if (dados.especie === 'EMO') {
      saldo = +anterior - +dados.valor_empenho;
    } else {
      saldo = +dados.total_empenho_sem_anulacao + +dados.valor_empenho;
    }

    const conteudo = [
      [
        { text: 'UNIDADE', border: [true, false, false, false] },
        {
          text: `${dados.ficha?.executora?.unidade?.codigo} ${dados.ficha?.executora?.unidade?.nome}`,
          border: [false, false, true, false]
        },
        { text: dados.especie === 'EMO' ? 'DOTAÇÃO' : '', border: [true, false, false, false] },
        {
          text: dados.especie === 'EMO' ? this.funcaoService.convertToBrNumber(dotacao) : '',
          border: [false, false, true, false], alignment: 'right'
        },
      ], [
        { text: 'EXECUTORA', border: [true, false, false, false] },
        { text: `${dados.ficha?.executora?.codigo} ${dados.ficha?.executora?.nome} `, border: [false, false, true, false] },
        { text: dados.especie === 'EMO' ? 'ANTERIOR' : 'EMPENHADO', border: [true, false, false, false] },
        {
          text: dados.especie === 'EMO' ?
            this.funcaoService.convertToBrNumber(anterior) : this.funcaoService.convertToBrNumber(+dados.total_empenho_sem_anulacao),
          border: [false, false, true, false], alignment: 'right'
        },
      ], [
        { text: 'NATUREZA', border: [true, false, false, false] },
        { text: `${this.funcaoService.mascarar('#.#.##.##', dados.ficha?.despesa?.codigo)} ${dados.ficha?.despesa?.nome}`, border: [false, false, true, false] },
        // { text: `${dados.subelemento.codigo.substring(0, 8)}`, border: [false, false, true, false] },
        { text: dados.especie === 'EMO' ? 'EMPENHADO' : 'ANULADO', border: [true, false, false, false] },
        {
          text: this.funcaoService.convertToBrNumber(+dados.valor_empenho),
          border: [false, false, true, false], alignment: 'right'
        },
      ], [
        { text: 'SUBELEMENTO', border: [true, false, false, false] },
        { text: `${dados.subelemento?.codigo} ${dados.subelemento?.nome} `, border: [false, false, true, false] },
        { text: 'SALDO ATUAL', border: [true, false, false, false] },
        { text: this.funcaoService.convertToBrNumber(saldo), border: [false, false, true, false], alignment: 'right' },
      ], [
        { text: 'FUNCIONAL', border: [true, false, false, false] },
        {
          // tslint:disable-next-line: max-line-length
          text: `${dados.ficha?.funcao?.codigo}.${dados.ficha?.subfuncao?.codigo}.${dados.ficha?.programa?.codigo} ${dados.ficha?.programa?.nome} `,
          border: [false, false, true, false]
        },
        { text: '', border: [true, false, false, false] },
        { text: '', border: [false, false, true, false] },
      ], [
        { text: 'AÇÃO', border: [true, false, false, false] },
        { text: `${dados.ficha?.acao?.codigo} ${dados.ficha?.acao?.nome} `, border: [false, false, true, false] },
        { text: '', border: [true, false, false, false] },
        { text: '', border: [false, false, true, false] },
      ], [
        { text: 'RECURSO', border: [true, false, false, true] },
        {
          text: `${dados.ficha?.aplicacao_variavel?.codigo ? dados.ficha?.aplicacao_variavel?.codigo : dados.ficha?.recurso?.codigo + ' ' + dados.ficha?.aplicacao?.codigo} ${dados.ficha?.aplicacao_variavel?.codigo ? dados.ficha?.aplicacao_variavel?.nome : dados.ficha?.aplicacao?.nome}`,
          border: [false, false, false, true]
        },
        { text: '', border: [true, false, false, true] },
        { text: '', border: [false, false, true, true] },
      ]
    ];

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        headerRows: 2,
        widths: [60, '*', 60, 50],
        body: conteudo
      }
    }];
  }

  private dadosFavorecido(dados: Empenho): {}[] {
    let bancoPrincipal = dados.favorecido.contas?.find((e) => (e.principal && e.orgao.id == dados.orgao.id));
    const conteudo = [
      [
        { text: 'DEVERÁ SER PAGO À:', colSpan: 3, border: [true, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, true, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, true, false] },
      ], [
        {
          text: `${dados.favorecido?.nome}`, colSpan: 3,
          fontSize: 11, bold: true, border: [true, false, false, false]
        },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: `CÓDIGO: ${dados.favorecido?.id}`, bold: true, border: [false, false, true, false] },
      ], [
        { text: 'CPF/CNPJ:', border: [true, false, false, false] },
        { text: `${dados.favorecido?.cpf_cnpj}`, border: [false, false, false, false] },
        { text: 'TIPO PESSOA:', border: [false, false, false, false] },
        {
          text: dados.favorecido?.tipo?.nome,
          border: [false, false, false, false]
        },
        { text: `BANCO: ${bancoPrincipal?.banco.nome ? bancoPrincipal?.banco.nome : ''}`, border: [false, false, true, false] },
      ], [
        { text: 'ENDEREÇO:', border: [true, false, false, false] },
        {
          text: `${dados.favorecido?.endereco}, ${dados.favorecido?.num_endereco} `,
          border: [false, false, false, false]
        },
        { text: 'BAIRRO:', border: [false, false, false, false] },
        { text: dados.favorecido?.bairro, border: [false, false, false, false] },
        { text: `AGÊNCIA: ${bancoPrincipal?.agencia ? bancoPrincipal?.agencia : ''}`, border: [false, false, true, false] },
      ], [
        { text: 'CIDADE:', border: [true, false, false, true] },
        { text: `${dados.favorecido?.municipio}, ${dados.favorecido?.uf} `, border: [false, false, false, true] },
        { text: 'TELEFONE:', border: [false, false, false, true] },
        { text: `(${dados.favorecido?.ddd_fone ? dados.favorecido?.ddd_fone : ''}) ${dados.favorecido?.telefone}     `, border: [false, false, false, true] },
        { text: `Nº CONTA: ${bancoPrincipal?.numero_conta ? bancoPrincipal?.numero_conta : ''}`, border: [false, false, true, true] },
      ],
    ];

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        widths: [60, '*', 60, 150, '*'],
        body: conteudo
      }
    }];
  }

  private dadosContrato(dados: Empenho): {}[] {

    const conteudo = [
      [
        { text: 'Contrato No.', fontSize: 7, border: [true, false, false, false] },
        { text: 'Aditivo', fontSize: 7, border: [true, false, false, false] },
        { text: 'Data Assinatura', fontSize: 7, border: [true, false, false, false] },
        { text: 'Data Início', fontSize: 7, border: [true, false, false, false] },
        { text: 'Data Término', fontSize: 7, border: [true, false, false, false] },
        { text: 'Convênio No.', fontSize: 7, border: [true, false, true, false] }
      ], [
        {
          text: dados.contrato?.numero ? dados.contrato?.numero : '-',
          alignment: 'center', bold: true, border: [true, false, false, true]
        },
        {
          text: dados?.contrato_aditamento?.numero ? dados?.contrato_aditamento?.numero : '-',
          alignment: 'center', fontSize: 6, bold: true, border: [true, false, false, true]
        },
        {
          text: dados.contrato?.data_assinatura ? this.funcaoService.converteDataBR(dados.contrato?.data_assinatura) : '-',
          alignment: 'center', border: [true, false, false, true]
        },
        {
          text: dados.contrato?.data_inicio ? this.funcaoService.converteDataBR(dados.contrato?.data_inicio) : '-',
          alignment: 'center', border: [true, false, false, true]
        },
        {
          text: dados.contrato_aditamento
            ? this.funcaoService.converteDataBR(dados.contrato_aditamento.data_termino)
            : dados.contrato
              ? this.funcaoService.converteDataBR(dados.contrato.data_termino)
              : '-',
          alignment: 'center', border: [true, false, false, true]
        },
        {
          text: dados.convenio?.numero ? dados.convenio?.numero : '-',
          alignment: 'center', bold: true, border: [true, false, true, true]
        }
      ]
    ];

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        headerRows: 2,
        widths: [110, 40, 85, 85, 85, '*'],
        body: conteudo
      }
    }];
  }

  private dadosHistorico(dados: Empenho): {}[] {
    // Abreviação da observação caso seja gigante.
    let partialObservation = '';
    if (dados.compra?.rcms?.observacao) {
      const { observacao } = dados.compra.rcms;
      partialObservation = observacao ? observacao.length > 220 ? `${observacao.substring(0, 220)}...` : observacao : '';
    }

    const conteudo = [
      [
        { text: 'Histórico:', border: [true, false, true, false] },
        { text: 'Observações', fontSize: 6, border: [true, false, true, false], colSpan: 2 },
        { text: ''/*, border: [false, false, true, false]*/ }
      ], [
        { text: `${(dados.historico.length > 500 ? dados.historico.substring(0, 450) + '...' : dados.historico)} `, border: [true, false, true, false] },
        { text: partialObservation, fontSize: 7, bold: true, border: [true, false, true, false], margin: [0, -5, 0, 0], colSpan: 2 },
        { text: ''/*, border: [false, false, true, false]*/ }
      ], [
        { text: '', border: [true, false, true, false] },
        { text: 'RCMS:  ' + `${dados?.compra?.rcms?.numero || ''}` + ' | ' + 'OF.:  ' + `${dados?.compra?.numero || ''}`, fontSize: 7, border: [true, false, true, false], colSpan: 2 },
        { text: '', border: [false, false, true, false] },
      ], [
        { text: '', border: [true, false, true, false] },
        { text: 'REQ.:  ' + `${dados?.compra?.rcms?.requerente?.nome || ''}`, fontSize: 7, border: [true, false, true, false], colSpan: 2 },
        { text: '', border: [false, false, true, false] },
      ], [
        { text: '', border: [true, false, true, false] },
        { text: 'Prazo:  ' + `${dados?.compra?.rcms?.prazo?.intervalo_qtd || ''} - ${dados?.compra?.rcms?.prazo?.intervalo || ''}`, fontSize: 7, border: [true, false, false, false] },
        { text: '', border: [false, false, true, false] },
      ], [
        { text: '', border: [true, false, true, false] },
        { text: 'VALOR....R$', fontSize: 9, bold: true, border: [true, true, false, false] },
        { text: `${this.funcaoService.convertToBrNumber(dados?.valor_empenho || 0)}`, fontSize: 9, bold: true, alignment: 'right', border: [false, true, true, false] },
      ], [
        { text: '', border: [true, false, true, true] },
        { text: 'LIQUIDO....R$', fontSize: 9, bold: true, border: [true, true, false, true] },
        { text: `${this.funcaoService.convertToBrNumber(dados?.valor_empenho || 0)}`, fontSize: 9, bold: true, alignment: 'right', border: [false, true, true, true] },
      ], [
        { text: 'Fica empenhado a importância de: ', border: [true, false, false, false], colSpan: 2 },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, true, false] }
      ], [
        {
          text: extenso(this.funcaoService.convertToBrNumber(dados.valor_empenho),
            { mode: 'currency', currency: { type: 'BRL' } }).toUpperCase(),
          border: [true, false, false, false], margin: [0, 0, 0, 0]
        },
        { text: 'VALOR R$:', bold: true, fontSize: 11, border: [false, false, false, false], alignment: 'right' },
        {
          text: this.funcaoService.convertToBrNumber(dados.valor_empenho),
          alignment: 'center', bold: true, fontSize: 13, border: [false, false, true, false], margin: [0, 0, 0, 5]
        },
      ],
    ];

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        heights: [5, 5],
        widths: ['*', 60, 100],
        body: conteudo
      }
    }];
  }

  private async dadosAutorizacao(dados: Empenho): Promise<{}[]> {
    const unidade: Unidade = dados.ficha?.executora?.unidade
    const executora: Executora = dados.ficha?.executora
    const funcao = dados.ficha?.funcao?.codigo;
    const data_liquidacao = dados.liquidacoes?.length == 1 ?
      dados.liquidacoes[0]?.data_liquidacao : dados.liquidacoes[dados.liquidacoes?.length - 1]?.data_liquidacao;

    const assinatura = await this.assinaturaService.obter({
      orgao_id: this.log.orgao.id,
      'data_limite$ge': String(this.funcaoService.converteDataSQL(new Date(dados.data_empenho))),
      orderBy: 'data_limite'
    }).toPromise();
    if (assinatura) {
      this.ordenador_despesa = assinatura.ordenador_despesa;
      this.cargo_ordenador_despesa = assinatura.cargo_ordenador_despesa;

      this.ordenador_despesa_funcao_03 = assinatura.ordenador_despesa_funcao_03;
      this.cargo_ordenador_despesa_funcao_03 = assinatura.cargo_ordenador_despesa_funcao_03;

      this.ordenador_despesa_funcao_06 = assinatura.ordenador_despesa_funcao_06;
      this.cargo_ordenador_despesa_funcao_06 = assinatura.cargo_ordenador_despesa_funcao_06;

      this.ordenador_despesa_funcao_08 = assinatura.ordenador_despesa_funcao_08;
      this.cargo_ordenador_despesa_funcao_08 = assinatura.cargo_ordenador_despesa_funcao_08;

      this.ordenador_despesa_funcao_10 = assinatura.ordenador_despesa_funcao_10;
      this.cargo_ordenador_despesa_funcao_10 = assinatura.cargo_ordenador_despesa_funcao_10;

      this.ordenador_despesa_funcao_11 = assinatura.ordenador_despesa_funcao_11;
      this.cargo_ordenador_despesa_funcao_11 = assinatura.cargo_ordenador_despesa_funcao_11;

      this.ordenador_despesa_funcao_12 = assinatura.ordenador_despesa_funcao_12;
      this.cargo_ordenador_despesa_funcao_12 = assinatura.cargo_ordenador_despesa_funcao_12;

      this.ordenador_despesa_funcao_13 = assinatura.ordenador_despesa_funcao_13;
      this.cargo_ordenador_despesa_funcao_13 = assinatura.cargo_ordenador_despesa_funcao_13;

      this.ordenador_despesa_funcao_15 = assinatura.ordenador_despesa_funcao_15;
      this.cargo_ordenador_despesa_funcao_15 = assinatura.cargo_ordenador_despesa_funcao_15;

      this.ordenador_despesa_funcao_16 = assinatura.ordenador_despesa_funcao_16;
      this.cargo_ordenador_despesa_funcao_16 = assinatura.cargo_ordenador_despesa_funcao_16;

      this.ordenador_despesa_funcao_18 = assinatura.ordenador_despesa_funcao_18;
      this.cargo_ordenador_despesa_funcao_18 = assinatura.cargo_ordenador_despesa_funcao_18;

      this.ordenador_despesa_funcao_20 = assinatura.ordenador_despesa_funcao_20;
      this.cargo_ordenador_despesa_funcao_20 = assinatura.cargo_ordenador_despesa_funcao_20;

      this.ordenador_despesa_funcao_23 = assinatura.ordenador_despesa_funcao_23;
      this.cargo_ordenador_despesa_funcao_23 = assinatura.cargo_ordenador_despesa_funcao_23;

      this.ordenador_despesa_funcao_26 = assinatura.ordenador_despesa_funcao_26;
      this.cargo_ordenador_despesa_funcao_26 = assinatura.cargo_ordenador_despesa_funcao_26;

      this.ordenador_despesa_funcao_27 = assinatura.ordenador_despesa_funcao_27;
      this.cargo_ordenador_despesa_funcao_27 = assinatura.cargo_ordenador_despesa_funcao_27;

      this.ordenador_pagto = assinatura.ordenador_pagto;
      this.cargo_ordenador_pagto = assinatura.cargo_ordenador_pagto;

      this.tesoureiro = assinatura.tesoureiro;
      this.cargo_tesoureiro = assinatura.cargo_tesoureiro;

      this.contador = assinatura.contador;
      this.cargo_contador = assinatura.cargo_contador;
    }

    if(executora.nome_assinatura?.length && executora.cargo_assinatura?.length){
      this.ordenador = executora.nome_assinatura
      this.cargoOrdenador = executora.cargo_assinatura
    }
    else if(unidade.nome_assinatura?.length && unidade.cargo_assinatura?.length){
      this.ordenador = unidade.nome_assinatura
      this.cargoOrdenador = unidade.cargo_assinatura
    }
    else {
      switch (funcao) {
        case '03':
          this.ordenador = this.ordenador_despesa_funcao_03;
          this.cargoOrdenador = this.cargo_ordenador_despesa_funcao_03;
          break;
        case '06':
          this.ordenador = this.ordenador_despesa_funcao_06;
          this.cargoOrdenador = this.cargo_ordenador_despesa_funcao_06;
          break;
        case '08':
          this.ordenador = this.ordenador_despesa_funcao_08;
          this.cargoOrdenador = this.cargo_ordenador_despesa_funcao_08;
          break;
        case '11':
          this.ordenador = this.ordenador_despesa_funcao_11;
          this.cargoOrdenador = this.cargo_ordenador_despesa_funcao_11;
          break;
        case '10':
          this.ordenador = this.ordenador_despesa_funcao_10;
          this.cargoOrdenador = this.cargo_ordenador_despesa_funcao_10;
          break;
        case '12':
          this.ordenador = this.ordenador_despesa_funcao_12;
          this.cargoOrdenador = this.cargo_ordenador_despesa_funcao_12;
          break;
        case '13':
          this.ordenador = this.ordenador_despesa_funcao_13;
          this.cargoOrdenador = this.cargo_ordenador_despesa_funcao_13;
          break;
        case '15':
          this.ordenador = this.ordenador_despesa_funcao_15;
          this.cargoOrdenador = this.cargo_ordenador_despesa_funcao_15;
          break;
        case '16':
          this.ordenador = this.ordenador_despesa_funcao_16;
          this.cargoOrdenador = this.cargo_ordenador_despesa_funcao_16;
          break;
        case '18':
          this.ordenador = this.ordenador_despesa_funcao_18;
          this.cargoOrdenador = this.cargo_ordenador_despesa_funcao_18;
          break;
        case '20':
          this.ordenador = this.ordenador_despesa_funcao_20;
          this.cargoOrdenador = this.cargo_ordenador_despesa_funcao_20;
          break;
        case '23':
          this.ordenador = this.ordenador_despesa_funcao_23;
          this.cargoOrdenador = this.cargo_ordenador_despesa_funcao_23;
          break;
        case '26':
          this.ordenador = this.ordenador_despesa_funcao_26;
          this.cargoOrdenador = this.cargo_ordenador_despesa_funcao_26;
          break;
        case '27':
          this.ordenador = this.ordenador_despesa_funcao_27;
          this.cargoOrdenador = this.cargo_ordenador_despesa_funcao_27;
          break;
        default:
          this.ordenador = this.ordenador_despesa;
          this.cargoOrdenador = this.cargo_ordenador_despesa;
      }
    }

    if (!this.ordenador || !this.cargoOrdenador) {
      this.ordenador = this.ordenador_despesa;
      this.cargoOrdenador = this.cargo_ordenador_despesa;
    }

    const conteudo = [
      [
        {
          text: 'AUTORIZAÇÃO EMPENHO',
          bold: true, border: [true, true, true, false], margin: [0, 0, 0, 10]
        },
        { text: 'CONTABILIZAÇÃO', border: [false, true, true, false], bold: true, },
        { text: 'LIQUIDAÇÃO', border: [false, true, true, false] }
      ], [
        { text: '_____________________________________', alignment: 'center', border: [true, false, true, false] },
        { text: '_____________________________________', alignment: 'center', border: [false, false, true, false] },
        { text: 'Documento:', border: [false, false, true, false] }
      ], [
        { text: this.ordenador, fontSize: 7, alignment: 'center', border: [true, false, true, false] },
        { text: this.contador ? this.contador : '', fontSize: 7, alignment: 'center', border: [false, false, true, false] },
        { text: dados.liquidacoes?.length == 1 ? dados.liquidacoes[0]?.documento : dados.liquidacoes[dados.liquidacoes?.length - 1]?.documento, border: [false, false, true, false], margin: [0, 5, 0, 5] }
      ], [
        { text: this.cargoOrdenador, fontSize: 7, alignment: 'center', border: [true, false, true, false], margin: [0, -7, 0, 0] },
        { text: this.cargo_contador ? this.cargo_contador : '', fontSize: 7, alignment: 'center', border: [false, false, true, false], margin: [0, -7, 0, 0] },
        { text: '', border: [false, false, true, false], margin: [0, 5, 0, 5] }
      ], [
        { text: 'Data: _____/_____/________', border: [true, false, true, true], margin: [0, -5, 0, 0] },
        { text: 'Data: _____/_____/________', border: [false, false, true, true], margin: [0, -5, 0, 0] },
        { text: data_liquidacao ? `Data: ${this.funcaoService.converteDataBR(data_liquidacao)}` : 'Data: _____/_____/________', border: [false, false, true, true], margin: [0, -5, 0, 0] }
      ],
    ];

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        widths: ['*', '*', '*'],
        body: conteudo
      }
    }];
  }

  private dadosAssinatura(log: Login, modelo: string): {}[] {
    const conteudo = [
      [
        { text: 'AUTORIZAÇÃO PAGAMENTO', border: [true, false, false, false], colSpan: 2 },
        { text: '', border: [true, false, false, false], },
        { text: '______________________________________', border: [false, false, false, false], margin: [20, 30, -20, 0] },
        { text: '______________________________________', border: [false, false, false, false], margin: [40, 30, -30, 0] },
        { text: '', border: [false, false, true, false] },
      ], [
        { text: 'BANCO:_______________', border: [true, false, false, false] },
        { text: '', border: [false, false, false, false], },
        {
          text: modelo === 'mod1'
            ? (this.ordenador_pagto ? this.ordenador_pagto : '')
            : (this.ordenador ? this.ordenador : ''), fontSize: 7, alignment: 'center', border: [false, false, false, false], margin: [10, 0, -20, 0]
        },
        { text: this.tesoureiro ? this.tesoureiro : '', fontSize: 7, alignment: 'center', border: [false, false, false, false], margin: [50, 0, -20, 0] },
        { text: '', border: [false, false, true, false], },
      ], [
        { text: 'RECURSO:_____________ CHEQUE:______________', border: [true, false, false, false] },
        { text: '', border: [false, false, false, false], },
        {
          text: modelo === 'mod1'
            ? (this.cargo_ordenador_pagto ? this.cargo_ordenador_pagto : '')
            : (this.cargoOrdenador ? this.cargoOrdenador : ''), alignment: 'center', fontSize: 7, border: [false, false, false, false], margin: [15, 0, -15, 10]
        },
        { text: this.cargo_tesoureiro ? this.cargo_tesoureiro : '', alignment: 'center', fontSize: 7, border: [false, false, false, false], margin: [50, 0, -15, 10] },
        { text: '', border: [false, false, true, false], },
      ], [
        { text: 'Data: _____/_____/________', border: [true, false, false, true], colSpan: 2 },
        { text: '', border: [false, false, false, false], },
        { text: '', border: [false, false, false, true], margin: [0, 0, 0, 10] },
        { text: '', border: [false, false, false, true], margin: [0, 0, 0, 10] },
        { text: '', border: [false, false, true, true] },
      ],
    ];

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        heights: [10, 0],
        widths: [100, 0, 150, 150, '*'],
        body: conteudo
      }
    }];
  }

  private dadosRecibo(): {}[] {
    const conteudo = [
      [
        { text: 'RECIBO E QUITAÇÃO', border: [true, false, false, false], colSpan: 2 },
        { text: '', border: [false, false, false, false], },
        { text: '', border: [false, false, false, false], },
        { text: '', border: [false, false, true, false], },
      ], [
        {
          text: 'Recebemos o valor a que se refere este empenho, ao qual damos plena e geral quitação.',
          border: [true, false, false, false], colSpan: 2, margin: [0, 0, 20, 0]
        },
        { text: '', border: [false, false, false, false], },
        { text: 'Assinatura', border: [false, false, false, false], },
        { text: 'Documento', border: [false, false, true, false], },
      ], [
        { text: 'Data: _____/_____/________', border: [true, false, false, true], colSpan: 2 },
        { text: '', border: [false, false, false, true], },
        { text: '__________________________', border: [false, false, false, true], },
        { text: '__________________________', border: [false, false, true, true], },
      ],
    ];

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        heights: [10, 0],
        widths: ['*', '*', '*', '*'],
        body: conteudo
      }
    }];
  }

  async processarEmpenho(empenho: any) {
    const arquivosOriginais = empenho['arquivos'] || [];

    if (!empenho[0]?.compra?.id || empenho['assinar']) return;

    try {
      const parametros = {
        'orgao.id': empenho[0].orgao.id,
        'exercicio.id': empenho[0].exercicio.id,
        'id': empenho[0]?.compra?.id,
        relations: [
          'operador', 'licitacao', 'subelemento', 'contrato_aditamento',
          'modalidade', 'favorecido.tipo', 'favorecido.contas', 'ficha.despesa',
          'ficha.acao', 'ficha.recurso', 'ficha.executora.unidade', 'ficha.aplicacao',
          'exercicio', 'orgao', 'contrato', 'requerente', 'estoque',
          'rcms.setor', 'prazo', 'empenho', 'empenho.exercicio',
          'itens.produto_unidade.produto', 'itens.produto_unidade.unidade',
          'prazo_entrega', 'prazo_pagamento', 'setor'
        ].join(',')
      };

      const compra: any = await this.compraService.filtrar(1, -1, parametros).toPromise();

      if (!compra?.content?.length) {
        toastr.warning(`Ordem(s) de fornecimento não encontrada.`);
        return;
      }

      const notaCompra = new NotaCompra(this.assinaturaService, this.compraService, this.log, null, false, this.propostaService);
      const arquivoCompraUrl = await notaCompra.exportar(compra.content);

      empenho['arquivos'] = [{ url: arquivoCompraUrl, tipo: 'application/pdf' }];

      if (empenho[0]?.compra?.rcms?.id) {
        const rcmsId = empenho[0].compra.rcms.id;

        const [dadosRcms, itensRcms, favorecidosRcms]: any[] = await Promise.all([
          this.rcmsService.obter({
            id: rcmsId,
            'exercicio.id': empenho[0].exercicio.id,
            'orgao.id': empenho[0].orgao.id,
            relations: [
              "setor", "licitacao", "contrato", "contrato_aditamento", "exercicio",
              "orgao", "ficha", "ficha.despesa", "subelemento", "requerente",
              "modalidade", "operador", "ficha.executora.unidade", "ficha.recurso",
              "ficha.acao", "ficha.aplicacao", "responsavel_cotacao",
              "responsavel_fiscalizacao", "estoque"
            ]
          }).toPromise(),

          this.rcmsItemService.filtrar(1, -1, {
            "rcms.id": rcmsId,
            relations: [
              "produto_unidade", "produto_unidade.produto.aliquota",
              "produto_unidade.produto.material.aliquota", "produto_unidade.unidade",
              "cotacoes", "cotacoes.rcmsFavorecido", "cotacoes.rcmsFavorecido.favorecido"
            ],
            orderBy: ["ordem$ASC", "cotacoes.id$DESC"]
          }).toPromise(),

          this.rcmsFavorecidoService.filtrar(1, -1, {
            "rcms.id": rcmsId,
            relations: ["favorecido", "favorecido.tipo"],
            orderBy: "id$DESC"
          }).toPromise()
        ]);

        const storageRcms: any = await this.storageService.filtrar(1, -1, {
          'rcms.id': rcmsId,
          'assinatura': false,
          orderBy: 'data_cadastro$DESC',
        }).toPromise();
        dadosRcms.itens = itensRcms.content;
        dadosRcms.favorecidos = favorecidosRcms.content;
        dadosRcms['arquivos'] = storageRcms?.content?.length ? storageRcms.content : [];
        dadosRcms['novaAba'] = false;
        dadosRcms['incluirNota'] = true;
        dadosRcms['notaEmpenho'] = true;

        this.cd.detectChanges();
        await new Promise(resolve => setTimeout(resolve, 10));
        this.nota = new NotaRcmsRpt(this.pendenciaAssinaturaService, this.cd)

        this.nota.imprimirNotaRcmsRptComponent = new ImprimirNotaRcmsRpt(null, null, this.pendenciaAssinaturaService, this.storageService, null);
        this.nota.imprimirNotaRcmsRptComponent.rcms = [dadosRcms];
        this.nota.imprimirNotaRcmsRptComponent.url = true;
        this.nota.imprimirNotaRcmsRptComponent.download = true;
        this.nota.imprimirNotaRcmsRptComponent.unificarArquivos = true;
        this.arquivosSubject.next(null);
        const promessaPdf = this.arquivosSubject.pipe(
          filter(d => !!d),
          first()
        ).toPromise();
        if (!this.nota.imprimirNotaRcmsRptComponent.href) {
          this.nota.imprimirNotaRcmsRptComponent.href = new EventEmitter<any>();
        }
        this.nota.imprimirNotaRcmsRptComponent.href.subscribe(blob => {
          this.arquivosSubject.next(blob);
        });

        this.nota.rcms = [dadosRcms];
        this.nota.url = true;
        this.nota.download = true;
        this.nota.unificarArquivos = true;
        if (!this.nota.href) {
          this.nota.href = new EventEmitter<any>();
        }
        await this.nota.show();
        const dadosRcmsUrl = await promessaPdf;

        if (dadosRcmsUrl) {
          empenho['arquivos'].push({ url: dadosRcmsUrl['blob'], tipo: 'application/pdf' });
        }
      }
      if (arquivosOriginais.length) {
        for (const arq of arquivosOriginais) {
          empenho['arquivos'].unshift(arq);
        }
      }
    } catch (error) {
      this.funcaoService.acaoErro(error);
    }
  }

  private abrirOuBaixarBlob(blob: Blob, download: boolean, urlOnly: boolean) {
    const url = URL.createObjectURL(blob);
    if (urlOnly) return url;

    if (download) {
      const link = document.createElement('a');
      link.href = url;
      link.download = 'notas_empenho.pdf';
      link.click();
    } else {
      window.open(url, '_blank');
    }
  }

}
